<template>
  <!--展示-->
  <div class="">
    <header-nav :navInfo="navInfo"
                @backFunc="backFunc"></header-nav>

    <div class="page-body">
      <div class="item-box">
        <!--pc与移动不一样-->
        <a class="item"
           target="_blank"
           href="mqqwpa://im/chat?chat_type=wpa&uin=2427625188&version=1&src_type=web&web_src=lvlingseeds.com"><img src="@/assets/user/customer_QQ.png"> </a>
        <div class="item"><img src="@/assets/user/customer_Wechat.png"> </div>
      </div>
      <p class="hotline">客服热线：<a href="tel:0756-3399227">0756-3399227</a></p>
      <p class="hotline">传真电话：<a href="tel:0756-3391980">0756-3391980</a></p>
    </div>
  </div>
</template>

<script>
import HeaderNav from '@/components/head-nav'

export default {
  name: "index",
  props: ['userData'],
  components: {
    HeaderNav
  },
  data () {
    return {
      navInfo: {
        tit: '联系客服'
      },
    }
  },
  methods: {

    backFunc () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.page-body {
  width: 100%;
  height: auto;
  padding: 0 28px;
  margin-top: 20px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.item-box {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-bottom: 15px;
}
.item-box > .item {
  flex: 1;
  display: block;
  margin: 10px;
  width: 140px;
}
.item-box > .item img {
  width: 100%;
}
.hotline {
  font-size: 18px;
  color: #212121;
  text-align: center;
}
.hotline::before {
  content: "";
  display: inline-block;
  width: 24px;
  height: 24px;
  margin-right: 10px;
  vertical-align: middle;
  background: url("~@/assets/user/customer_tel.png") no-repeat;
  -webkit-background-size: 100%;
  background-size: 100%;
}
.hotline > a {
  color: #40beff;
  text-decoration: none;
}
</style>